export default class Menu {
    constructor(element, id)
    {
        this.menuLoaded = false;
        this.element = element;
        this.jq_element = $('#' + id);
        this.id = id;
        this.target = "";
        this.menuItems = this.jq_element.children("li");
        this.last_element = this.jq_element.children("li").length;
        this.animateCount = 0;
        this.isAnimating = false;
        this.element.onanimationend = (el) => {
            this.animateCount++;
            if (!this.menuLoaded) {
                this.menuLoaded = true;
                return;
            }
            
            if (this.animateDone()) {
                this.reset();
            }
        };
        this.element.onanimationstart = () => {
            this.isAnimating = true;
        };
        this.setMenuItem();
    }
    
    animateDone()
    {
        return this.animateCount == this.last_element;
    }
    setMenuItem()
    {
        var menu_items = $("#" + this.id).children(".menu-item");
        
        // $.each(menu_items, function(index) {
        //   this.menuItems.push(new MenuItem(this));
        // });
    }
    menuItem()
    {
        return this.menuItems;
    }
    
    animate(class_animation = "in-from-right",showing = true) {
        
        var list = this.jq_element.children("li");
        var num = 0;
        var total_num = (list.length * 200) + 600;
        this.isDisplaying = showing;
        
        list.each(function(index) {
            num += 100;
            var source = $(this);
            // console.log(400 + num);
    
            setTimeout(function() {
                source.addClass(class_animation)
                .css("opacity", 1);
            }, 300 + num);      
          
        })
        
        return 0;
    }
    
    reset() {
        if (this.isDisplaying) {
            this.menuItem().addClass("visible");
        } else {
            this.menuItem().removeClass("visible").removeClass('in-from-right').removeClass('out-to-left').removeAttr('style').css("opacity", 0);
        }
    }
    
    resetMenuSettings()
    {
        // console.log("THe id" + this.id);
        this.jq_element
            .removeClass("first-column")
            .removeClass("second-column")
            .addClass("hidden")
            .removeAttr('style');
        $.each(this.menuItem(), function(index) {
            // console.log($(this).hasClass('out-to-left'))
           $(this).removeClass("in-from-right")
            .removeClass("in-from-left")
            .removeClass("out-to-left")
            .removeClass("visible")
            .removeAttr('style')
            .css("opacity", 0);
        });
            
    }
}